module.exports = __webpack_public_path__ + "static/media/help.0c8aadb5.svg";